import { combineReducers } from 'redux-immutable';
import { fromJS } from 'immutable';

import { actionTypes } from './constants';
import { initialState } from 'common/constants/initialState';

export const initListState = fromJS({
  list: [],
  meta: {
    page: 0,
    perPage: 0,
    total: 0,
  },
  isLoading: false,
  error: null,
});

function fallThroughReasonsListReducer(state = initListState, action) {
  switch (action.type) {
    case actionTypes.FETCH_FALL_THROUGH_REASONS_LIST_IS_LOADING:
      return state.set('isLoading', action.payload);
    case actionTypes.FETCH_FALL_THROUGH_REASONS_LIST:
      return state
        .set('list', fromJS(action.payload.data))
        .set('meta', fromJS(action.payload.meta));
    case actionTypes.FETCH_FALL_THROUGH_REASONS_LIST_ERROR:
      return state.set('error', action.payload);
    case actionTypes.RESET_FALL_THROUGH_REASONS_LIST:
      return initListState;
    default:
      return state;
  }
}

const initItemState = fromJS({
  itemActionRequestState: initialState,
});

function fallThroughReasonReducer(state = initItemState, action) {
  switch (action.type) {
    case actionTypes.CREATE_OR_UPDATE_FALL_THROUGH_REASON_IS_LOADING:
      return state.setIn(['itemActionRequestState', 'isLoading'], action.payload);
    case actionTypes.SET_FALL_THROUGH_REASON_ACTION_RESULT:
      return state.setIn(['itemActionRequestState', 'result'], action.payload);
    case actionTypes.FETCH_FALL_THROUGH_REASON_ERROR:
      return state.setIn(['itemActionRequestState', 'error'], fromJS(action.payload));
    case actionTypes.RESET_FALL_THROUGH_REASON:
      return initItemState;
    default:
      return state;
  }
}

export default combineReducers({
  fallThroughReasonsList: fallThroughReasonsListReducer,
  fallThroughReason: fallThroughReasonReducer,
});
